import type { FC } from 'react';
import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';

const PageContainer: FC = ({ children }) => (
  <Box backgroundColor={{ _: 'neutral.0', md: 'neutral.30' }}>{children}</Box>
);

export default PageContainer;
